import styles from '../searchLocation.module.scss'
import {useState} from 'react'
import CustomHeader from '../../../navigation/top/CustomHeader'
import SearchLocation from '../SearchLocation'

// 웨딩홀 데이터 타입
interface HallData {
	uuid: string
	bizName: string | null
	name: string
	type: number
	typeName: string
	csState: string | null
	tel: string | null
	address: string | null
	address2: string | null
	region: string
	logoUrl: string | null
	coverUrl: string | null
	profile: string | null
	profileUrl: string | null
	reviewCnt: number | null
	oldReviewCnt: number | null
	isRegister: boolean | null
	modTsp: string | null
	rankUp: boolean | null
	isNew: boolean | null
	isLike: boolean | null
	promotionInfo: string | null
	promotionCnt: number | null
	rating: number
	memoContent: string | null
	tags: string | null
	benefits: string | null
	styleFilter: string | null
	regTsp: string | null
}

let controller: AbortController | null = null
let searchedKeyword = ''

export const fetchWeddingHallData = async (
	name: string,
	api: {
		url: string
		headers?: {
			Authorization: string
		}
	}
) => {
	// if (searchedKeyword === name.trim()) return null
	searchedKeyword = name.trim()
	if (name.trim() === '') {
		return []
	}

	// // 이전 요청 취소
	// if (controller) {
	// 	controller.abort()
	// }
	// 새로운 AbortController 생성
	// controller = new AbortController()
	// const signal = controller.signal

	const response = await fetch(api.url + name, {
		headers: api?.headers,
		// signal,
	})

	if (!response.ok) {
		throw new Error('Network response was not ok')
	}

	const data: {item: HallData[]} = await response.json()
	return data.item || []
}

export const SearchWeddingHallModal = ({
	isShow,
	hideModal,
	onCompleted,
	env,
	queryKey,
	api,
	title,
	placeholder,
	noResultText,
	noResultButton,
	queryClient,
}: {
	isShow: boolean
	hideModal: () => void
	onCompleted: (value: any) => void
	env: 'dev' | 'stg' | 'prod'
	queryKey?: string
	api?: {
		url?: string
		headers?: {
			Authorization: string
		}
	}
	title?: string
	placeholder?: string
	noResultText?: string
	noResultButton?: {
		text: string
		onClick: () => void
	}
	queryClient: any
}) => {
	const shouldUseEuro = (input: string) => {
		// 한글 유니코드 범위: \uAC00-\uD7A3
		const HANGUL_START = 0xac00
		const HANGUL_END = 0xd7a3

		// 영어와 숫자 발음을 기준으로 받침 여부 결정
		const NUMERIC_RULES: {[key: string]: boolean} = {
			// 숫자 발음
			'0': true,
			'1': false,
			'2': false,
			'3': true,
			'4': false,
			'5': false,
			'6': true,
			'7': false,
			'8': false,
			'9': false,
		}

		// 입력이 한글인지 확인
		if (/^[가-힣]$/.test(input)) {
			const charCode = input.charCodeAt(0)
			if (charCode >= HANGUL_START && charCode <= HANGUL_END) {
				const jongseong = (charCode - HANGUL_START) % 28 // 종성 계산
				if (jongseong === 0) {
					return 0 // 받침 없음 -> "로"
				} else if (jongseong === 8) {
					return 0 // 받침 ㄹ -> "로"
				} else {
					return 1 // 받침 있음 -> "으로"
				}
			}
		}

		// 입력이 영어인 경우 -로/-으로 모두 없이 보내기 위해 3으로 리턴
		if (/^[a-zA-Z]$/.test(input)) {
			return 3
		}

		// 입력이 숫자인 경우 발음에 따라 결정
		if (/^[0-9]$/.test(input)) {
			return NUMERIC_RULES[input] ? 1 : 0 // 규칙 매핑
		}
		// 그 외: false
		return 0
	}
	const [keyword, setKeyword] = useState('')
	const searchQueryKey = queryKey || 'searchWeddingHall'
	const searchTitle = title || `웨딩홀을\n검색하세요.`
	const searchPlaceholder = placeholder || '업체명을 검색해 주세요.'
	const searchNoResultText =
		noResultText ||
		`${shouldUseEuro(keyword.slice(-1)) === 0 ? '로' : shouldUseEuro(keyword.slice(-1)) === 1 ? '으로' : ''} 직접 입력할까요?`

	const searchNoResultButton = noResultButton || {
		text: '이대로 직접 입력',
	}
	const BASE_URL =
		env === 'prod'
			? 'https://app.wdgbook.com'
			: env === 'stg'
				? 'https://stg-wbapp-api.h2m.io'
				: 'https://dev-wbapp-api.h2m.io'

	const searchAPI = {
		url: `${BASE_URL}/v3/20240404/partner/auto?type=2&fetchStart=0&fetchSize=30&name=`,
		...api,
	}

	return (
		<>
			<div
				className={`${styles['search-select-modal']} ${styles[isShow ? 'is-open' : 'is-close']}`}
			>
				<CustomHeader
					linkItem={{
						name: '닫기',
						callback: hideModal,
					}}
					headerPostion='relative'
					scrollHide={false}
				/>
				{isShow && (
					<SearchLocation
						{...{
							keyword,
							setKeyword: (value: string) => setKeyword(value),
							onCompleted,
							hideModal,
							queryKey: searchQueryKey,
							api: searchAPI,
							title: searchTitle,
							placeholder: searchPlaceholder,
							noResultText: searchNoResultText,
							noResultButton: searchNoResultButton,
							fetchSearchData: () => fetchWeddingHallData(keyword, searchAPI),
							isAllowCustomValue: true,
							queryClient,
						}}
					/>
				)}
			</div>
		</>
	)
}
